import { Model } from 'vuex-orm';

import User from '../user/model';

export default class Profile extends Model {
  static entity = 'profiles';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      first_name: this.attr(''),
      last_name: this.attr(''),
      full_name: this.attr(''),
      address: this.attr(''),
      address2: this.attr(''),
      city: this.attr(''),
      state: this.attr(''),
      zip: this.attr(''),
      phone: this.attr(''),
      title: this.attr(''),
      starting_date: this.attr(''),

      user: this.belongsTo(User, 'user_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/model.js